import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { TimeZoneProvider } from '@atlassian/jira-issue-view-activity-common/src/context/timezone/index.tsx';
import type { Props } from './types.tsx';
import IssueHistory from './ui/index.tsx';

const IssueHistoryContainer = ({
	baseUrl,
	issueKey,
	timeZone,
	sortOrder,
	GroupedActivityEntryComponent,
	issueViewRelayFragment,
}: Props) => (
	<JSErrorBoundary id="issue-history">
		<TimeZoneProvider value={timeZone}>
			<IssueHistory
				baseUrl={baseUrl}
				issueKey={issueKey}
				sortOrder={sortOrder}
				GroupedActivityEntryComponent={GroupedActivityEntryComponent}
				issueViewRelayFragment={issueViewRelayFragment}
			/>
		</TimeZoneProvider>
	</JSErrorBoundary>
);

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { default as HistoryItemComponent } from './ui/history-items/history-item';

export default IssueHistoryContainer;

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { default as HistoryItem } from './common/ui/history-item/index';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { useIssueHistoryUi } from './state/context';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { default as Change } from './common/ui/change';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { default as GroupedChange } from './common/ui/grouped-change';
